import BaseEnum from "./base_enum.js";

class ProjectMediationTypeEnumDesc extends BaseEnum {

  name() {
    return "project_mediation_type";
  }

  rawValues() {
    return ["medi2", "medi_2a", "medi_2c"];
  }

}

const ProjectMediationTypeEnum = new ProjectMediationTypeEnumDesc();
export default ProjectMediationTypeEnum;
